// Stock bucket categories and types

export type BucketCategory = 'functional' | 'sectoral' | 'historical' | 'important';

export interface Bucket {
  id: string;
  title: string;
  description: string;
  companyCount: number;
  category: BucketCategory;
  hasChildBuckets?: boolean;
  childBucketCount?: number;
}

export const bucketCategories: { id: BucketCategory; label: string }[] = [
  { id: 'functional', label: 'Functional' },
  { id: 'sectoral', label: 'Sectoral' },
  { id: 'historical', label: 'Historical' },
  { id: 'important', label: 'Important' },
];
